import debounce from 'lodash/debounce';
import React from 'react';
import classnames from 'classnames';
import { Dropdown, Menu } from 'antd';
import i18n, { changeLanguage } from '@/i18n/i18n';
import ChevronDown from './chevronDown';
import IconLang from './lang';

const languagesMap: any = {
	en: 'English',
	ja: '日本語',
};

interface LanguageSwitchProps {
	useInLogin?: boolean;
	onChange?: any
}

const LanguageSwitch = (props: LanguageSwitchProps) => {
	const { useInLogin = true } = props;
	const [currentLang, setCurrentLang] = React.useState(i18n.language);
	const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

	function onChangeLanguage(lang: any) {
		changeLanguage(lang);

		setCurrentLang(lang);
	}

	React.useEffect(() => {
		const resize = debounce(() => {
			setWindowWidth(window.innerWidth);
		}, 100);

		window.addEventListener('resize', resize);

		return () => {
			window.removeEventListener('resize', resize);
		};
	}, []);

	if (windowWidth < 1000 && !useInLogin) {
		return <React.Fragment />;
	}

	const menu = () => {
		return (
			<Menu>
				{Object.entries(languagesMap).map(([key, text]) => {
          const name: any = text;

					return (
						<Menu.Item key={key} onClick={() => onChangeLanguage(key)}>
							{name}
						</Menu.Item>
					);
				})}
			</Menu>
		);
	};

	return (

		<Dropdown trigger={['click']} overlay={menu} className={classnames({ languange: true, useInLogin: useInLogin })}>
			<div>
				<IconLang style={{ fontSize: '12px' }} />
				<span>&nbsp;{languagesMap[currentLang]}</span>
				<ChevronDown />
			</div>
		</Dropdown>
	);
};

export default LanguageSwitch;
